import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vcfraxgkuadgydawrtcp.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjZnJheGdrdWFkZ3lkYXdydGNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzExODMwMzcsImV4cCI6MjA0Njc1OTAzN30.oEhXuBLqyWOpEF050uzWiZyAiGBCJVq6EfTwQXcLIoA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);